// Extraído do MontadorPistaHipismo.vue — utilitários Bézier e raio de curvatura

export function cubicPointAt(t, P0, C1, C2, P3) {
  const u = 1 - t
  const uu = u * u
  const tt = t * t
  const uuu = uu * u
  const ttt = tt * t
  return {
    x: uuu * P0.x + 3 * uu * t * C1.x + 3 * u * tt * C2.x + ttt * P3.x,
    y: uuu * P0.y + 3 * uu * t * C1.y + 3 * u * tt * C2.y + ttt * P3.y,
  }
}

// Vetor tangente da Bézier cúbica em t
export function cubicTangentAt(t, P0, C1, C2, P3) {
  const u = 1 - t
  return {
    x: 3 * u * u * (C1.x - P0.x) + 6 * u * t * (C2.x - C1.x) + 3 * t * t * (P3.x - C2.x),
    y: 3 * u * u * (C1.y - P0.y) + 6 * u * t * (C2.y - C1.y) + 3 * t * t * (P3.y - C2.y),
  }
}

// Raio de curvatura no início (t≈0) e no fim (t≈1) da Bézier
export function radiusAtStart(P0, C1, C2) {
  const d1 = { x: 3 * (C1.x - P0.x),          y: 3 * (C1.y - P0.y) }
  const d2 = { x: 6 * (P0.x - 2*C1.x + C2.x), y: 6 * (P0.y - 2*C1.y + C2.y) }
  const cross = Math.abs(d1.x * d2.y - d1.y * d2.x)
  const v2 = d1.x * d1.x + d1.y * d1.y
  return cross < 1e-9 ? Infinity : Math.pow(v2, 1.5) / cross
}

export function radiusAtEnd(C1, C2, P3) {
  const d1 = { x: 3 * (P3.x - C2.x),          y: 3 * (P3.y - C2.y) }
  const d2 = { x: 6 * (C1.x - 2*C2.x + P3.x), y: 6 * (C1.y - 2*C2.y + P3.y) }
  const cross = Math.abs(d1.x * d2.y - d1.y * d2.x)
  const v2 = d1.x * d1.x + d1.y * d1.y
  return cross < 1e-9 ? Infinity : Math.pow(v2, 1.5) / cross
}
